export enum TipoPessoaEnum {
  PESSOA_FISICA = "PESSOA_FISICA",
  PESSOA_JURIDICA = "PESSOA_JURIDICA",
}
